export default "__VITE_ASSET__BeGOrKhs__"